module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "contact-item contacts-show",
    attrs: {
      "id": "contacts-show"
    }
  }, [_c('back-link'), _c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "contacts-show__title-wrapper"
  }, [_c('span', {
    staticClass: "title",
    class: _vm.contact.stage
  }, [_vm._v(_vm._s(_vm.contact.full_name))])]), (_vm.has_business) ? _c('p', [_c('router-link', {
    staticClass: "link sub-header",
    attrs: {
      "to": '/contatos/empresas/' + _vm.contact.business.id
    }
  }, [_vm._v(_vm._s(_vm.contact.business.name))])], 1) : _c('p', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(_vm.contact.base_business_name || "-"))])]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "dropdown pull-right"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "remove-contact",
    on: {
      "click": _vm.removeContact
    }
  }, [_vm._v("Excluir")])])])]) : _vm._e(), _c('div', {
    staticClass: "spacer-15 pull-right"
  }), (!_vm.current_user.isMonitoringManager() && _vm.show_new_task_button) ? _c('button', {
    staticClass: "btn btn-clean pull-right",
    attrs: {
      "id": "open-task-modal-form-btn"
    },
    on: {
      "click": function($event) {
        return _vm.newTask($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v("Nova Tarefa")]) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row",
    on: {
      "change": _vm.setDirty
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('aside', {
    staticClass: "sidebar"
  }), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Estágio")]), _c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    class: _vm.contactItemStageClasses(),
    attrs: {
      "type": "button",
      "data-toggle": _vm.contactStageDropdownAvailable()
    }
  }, [_c('div', {
    staticClass: "contact-stage"
  }, [_vm._v(_vm._s(_vm.contact.human_stage))])]), (!_vm.current_user.isMonitoringManager()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.contact.next_valid_stages), function(next_stage_options, next_stage) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.setLostInfo({
            stage: next_stage
          })
        }
      }
    }, [_vm._v(_vm._s(next_stage_options.human_name))])])
  }), 0) : _vm._e()])]), _c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "dropdown hover-margin-status"
  }, [_c('a', {
    staticClass: "margin-status",
    class: _vm.contactItemStatusClasses(),
    attrs: {
      "type": "button",
      "data-toggle": _vm.contactStatusDropdownAvailable()
    }
  }, [_c('span', {
    class: _vm.contactStatusIconClass()
  }), _c('div', {
    staticClass: "contact-status"
  }, [_vm._v(_vm._s(_vm.contact.human_recipient_status))])]), (!_vm.current_user.isMonitoringManager()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.contact.next_valid_recipient_statuses), function(next_status_options, next_status) {
    return _c('li', [_c('a', {
      class: {
        "show-connected-options": next_status == "connected"
      },
      on: {
        "click": function($event) {
          return _vm.updateContactRecipient($event, {
            status: next_status
          })
        }
      }
    }, [_vm._v(_vm._s(next_status_options.human_action_name)), _c('ul', {
      staticClass: "dropdown-menu connected-options",
      staticStyle: {
        "display": "none"
      }
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndSendToNewFlow($event)
        }
      }
    }, [_vm._v("Enviar para fluxo")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndCreateTask($event)
        }
      }
    }, [_vm._v("Criar tarefa")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndChangeStage($event)
        }
      }
    }, [_vm._v("Alterar estágio")])]), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.connectedAndLost($event)
        }
      }
    }, [_vm._v("Perdido")])])])])])
  }), (_vm.contact.recipient_status == 'converting') ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openScheduleReactivationModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()], 2) : _vm._e()])]), _c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Fluxo Atual")]), (_vm.flow && _vm.flow.id) ? _c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: {
      'semi-automatic-flow': _vm.flow.semi_automatic
    },
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.flow.name)), (!_vm.current_user.isMonitoringManager()) ? _c('span', {
    staticClass: "gray-bold-caret"
  }) : _vm._e()]), (_vm.show_flow_dropdown && !_vm.current_user.isMonitoringManager()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "show_flow_autocomplete"
  }, [_vm._v("Alterar Fluxo"), _c('flow-autocomplete', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "contact": _vm.contact
    },
    on: {
      "flow-selected": _vm.updateContactInfo
    }
  })], 1), _c('a', {
    on: {
      "click": _vm.viewFlow
    }
  }, [_vm._v("Visualizar Fluxo")]), _c('a', {
    on: {
      "click": _vm.openRemoveContactFromFlowModal
    }
  }, [_vm._v("Remover Contato")])])]) : _vm._e()]) : _c('div', {
    staticClass: "dropdown none"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Nenhum"), (!_vm.current_user.isMonitoringManager()) ? _c('span', {
    staticClass: "gray-bold-caret"
  }) : _vm._e()]), (_vm.show_flow_dropdown && !_vm.current_user.isMonitoringManager()) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "show_flow_autocomplete"
  }, [_vm._v("Enviar para Fluxo"), _c('flow-autocomplete', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "contact": _vm.contact
    },
    on: {
      "flow-selected": _vm.updateContactInfo
    }
  })], 1)])]) : _vm._e()])]), (_vm.contact.lost_reason_title) ? _c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Motivo de perda")]), _c('span', [_vm._v(_vm._s(_vm.contact.lost_reason_title))])]) : _vm._e(), _c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Tag")]), _vm._l((_vm.contact.tags), function(tag) {
    return _c('tag', {
      attrs: {
        "tag": tag,
        "deletable": true
      },
      on: {
        "remove-tag": _vm.removeTag
      }
    })
  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "clickable inline",
    on: {
      "click": function($event) {
        return _vm.openTagsModal()
      }
    }
  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
  })]) : _vm._e()], 2), _c('li', [_c('div', {
    staticClass: "sidebar-menu-title"
  }, [_vm._v("Responsável")]), _c('user-dropdown', {
    attrs: {
      "contact": _vm.contact
    },
    on: {
      "update-contact": _vm.updateContact
    }
  }), _c('div', {
    staticClass: "clear"
  })], 1)])]), _c('div', {
    staticClass: "col-md-9"
  }, [_vm._m(1), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "details-tab",
      "role": "tabpanel"
    }
  }, [_c('contact-form', {
    attrs: {
      "contact": _vm.contact
    }
  })], 1), _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "events-tab",
      "role": "tabpanel"
    }
  }, [_c('label', [_vm._v("TAREFAS")]), _c('div', {
    staticClass: "spacer-15"
  }), _c('contact-tasks', {
    ref: "contact_tasks",
    attrs: {
      "prop_tooltip_placement": _vm.prop_tooltip_placement
    },
    on: {
      "open-template-modal": _vm.loadTaskInfo,
      "task-destroyed": _vm.taskDestroyed,
      "toggle-task-bar": _vm.toggleTaskBar
    }
  }), _c('div', {
    staticClass: "divider"
  }), _c('label', [_vm._v("HISTÓRICO DE ATIVIDADES")]), _c('div', {
    staticClass: "spacer-15"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user_can_edit_comment),
      expression: "user_can_edit_comment"
    }],
    staticClass: "add-comment"
  }, [_vm._m(2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_summernote),
      expression: "!show_summernote"
    }],
    staticClass: "add-comment-click clickable",
    on: {
      "click": function($event) {
        return _vm.toogleSummernote()
      }
    }
  }, [_vm._v("Clique aqui e escreva seu comentário")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_summernote),
      expression: "show_summernote"
    }],
    staticClass: "hide-summernote"
  }, [_c('textarea', {
    attrs: {
      "id": "comment",
      "name": "comment"
    }
  })]), (_vm.show_summernote) ? _c('div', {
    staticClass: "add-comment-click comment-buttons"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    on: {
      "click": function($event) {
        return _vm.cancelComment()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveComment()
      }
    }
  }, [_vm._v("Salvar")])]) : _vm._e()]), _c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")]), _c('contact-events', {
    ref: "contact_events"
  })], 1)])])]), (_vm.flow && _vm.flow.id) ? _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-contact-from-flow",
      "title": "Remover do fluxo",
      "confirm_text": "Remover",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmRemoveContactFromFlow
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Deseja remover o contato "), _c('strong', [_vm._v(_vm._s(_vm.contact.full_name))]), _vm._v(" do fluxo "), _c('strong', [_vm._v(_vm._s(_vm.flow.name))]), _vm._v("?")]), _c('br'), _c('div', [_c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v("Atenção")]), _vm._v(": a remoção desse contato irá afetar diretamente as estatísticas do fluxo.")])])]) : _vm._e(), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-contact",
      "title": "Excluir contato",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmRemoveContact
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma exclusão do contato abaixo?")]), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.contact.full_name))])])]), _c('tag-picker-modal', {
    ref: "tag_picker_modal",
    attrs: {
      "taggable": _vm.contact,
      "prop_id": _vm.tag_picker_id
    },
    on: {
      "picked": _vm.addTagsToContact
    }
  }), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
    staticStyle: {
      "top": "41.3%",
      "left": "32.2%"
    },
    attrs: {
      "contact": _vm.contact,
      "temp_attr": _vm.temp_attr
    },
    on: {
      "close-lost-reason-modal": function($event) {
        return _vm.closeLostReasonModal()
      },
      "update-contact-recipient": _vm.updateLostContact
    }
  }) : _vm._e(), _c('reactivate-recipient-modal', {
    attrs: {
      "contact": _vm.schedule_reactivation_contact
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary contact-show-actions btn-options dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("Opções")]), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tab-list",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#events-tab",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tarefas e Histórico")])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#details-tab",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Detalhes do Contato")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-comment-header"
  }, [_c('span', {
    staticClass: "contact-comment-icon"
  }, [_vm._v("Adicionar comentário")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfce0e46!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/show.vue
// module id = 1224
// module chunks = 1